<template>
  <section :class="{ padded: !unpadded, top }">
    <slot />
  </section>
</template>

<script setup lang="ts">
defineProps<{
  top?: boolean;
  unpadded?: boolean;
}>();
</script>

<style scoped lang="scss">
.padded {
  padding-bottom: var(--space-10);
  &.top {
    padding-top: var(--space-9);
  }
}

@media (max-width: 850px) {
  .padded {
    padding-bottom: var(--space-9);
    &.top {
      padding-top: var(--space-8);
    }
  }
}
</style>